import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  AdGroup,
  AdGroupRequest,
  AdGroupFilters,
  AdGroupsResponse,
  UpdateAdGroupPayload,
} from "../../schemas/adGroupSchema";

const GET_AD_GROUPS = gql`
  query GetAdGroups($page: Int, $pageSize: Int, $search: String) {
    adGroups(page: $page, pageSize: $pageSize, search: $search) {
      adGroups {
        id
        name
        description
        tenantId
        createdBy
        createdAt
        updatedAt
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_AD_GROUP_BY_ID = gql`
  query GetAdGroupById($id: ID!) {
    adGroup(id: $id) {
      id
      name
      description
      tenantId
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const CREATE_AD_GROUP = gql`
  mutation CreateAdGroup($input: CreateAdGroupInput!) {
    createAdGroup(input: $input)
  }
`;

const UPDATE_AD_GROUP = gql`
  mutation UpdateAdGroup($id: ID!, $input: UpdateAdGroupInput!) {
    updateAdGroup(id: $id, input: $input)
  }
`;

const DELETE_AD_GROUPS = gql`
  mutation DeleteAdGroups($ids: [ID!]!) {
    deleteAdGroups(ids: $ids)
  }
`;

export const adGroupService = {
  getAll: async (filters: AdGroupFilters = {}): Promise<AdGroupsResponse> => {
    const { data } = await client.query({
      query: GET_AD_GROUPS,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.adGroups;
  },

  getById: async (id: string): Promise<AdGroup> => {
    const { data } = await client.query({
      query: GET_AD_GROUP_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.adGroup;
  },

  create: async (input: AdGroupRequest): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_AD_GROUP,
      variables: { input },
    });
    return data.createAdGroup;
  },

  update: async (payload: UpdateAdGroupPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_AD_GROUP,
      variables: {
        id: payload.id,
        input: payload.adGroup,
      },
    });
    return data.updateAdGroup;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_AD_GROUPS,
      variables: { ids },
    });
    return data.deleteAdGroups;
  },
};
